export default __webpack_public_path__ + "static/media/HamburgerMenu.c839ade5.svg";